import React from 'react'

function Checkbox({ field, fieldName, type, checked }) {
  return (
    <label>
      <input {...field} type={type} checked={checked} />
      {fieldName}
    </label>
  )
}

export default Checkbox
